import React from 'react';
import NearbySpots from '../../components/spot-listing/nearby-spots';

const RenderNearbySpots = ({ spot, publicPark, nearbySpotSPhotos }) => {
    const items = [];

    spot.nearbySpots?.map((v, i) => {
        if (i < 3) {
            if (items[0]) {
                items[0].spots.push(v);
            } else {
                items[0] = { key: i, spots: [v] };
            }
        } else if (i < 6) {
            if (items[1]) {
                items[1].spots.push(v);
            } else {
                items[1] = { key: i, spots: [v] };
            }
        } else if (i < 9) {
            if (items[2]) {
                items[2].spots.push(v);
            } else {
                items[2] = { key: i, spots: [v] };
            }
        } else {
            if (items[3]) {
                items[3].spots.push(v);
            } else {
                items[3] = { key: i, spots: [v] };
            }
        }
    });

    if ((!spot.nearbySpots || !spot.nearbySpots?.length) && (!spot.nearbyParks || !spot.nearbyParks?.length)) {
        return '';
    }

    return (
        <>
            <div className="nearby-spots">
                <hr className="mt-4" />
                <h2 className="snif-m1 snif-semibold mt-3">{publicPark ? `Nearby private dog parks in ${spot.city}` : 'Other spots nearby'}</h2>
                <NearbySpots items={spot.nearbySpots} nearbySpotSPhotos={nearbySpotSPhotos} />
            </div>
            {publicPark && (
                <div className="nearby-spots pt-4">
                    <h2 className="snif-m1 snif-semibold mt-3">Nearby public dog parks in {spot.city}</h2>
                    <NearbySpots items={spot.nearbyParks} />
                </div>
            )}
        </>
    );
};

export default RenderNearbySpots;
